export default "__VITE_ASSET__9829d64f__"